



import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class AlbumFrames extends Vue {
  @Prop({required: false, type: String}) date!: string
  @Prop({required: false, type: Number, default: 1}) totalItem!: number
}
